"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContents = getContents;
exports.getContentsByVehicleId = getContentsByVehicleId;
exports.searchContentsByVehicleId = searchContentsByVehicleId;
exports.getImageMaps = getImageMaps;
exports.getAsset = getAsset;
exports.getFile = getFile;
exports.getHeroShot = getHeroShot;
exports.preloadHeroShot = preloadHeroShot;
exports.setSearchQuery = setSearchQuery;

var _ = require("./");

var _ContentDelivery = _interopRequireDefault(require("../services/ContentDelivery"));

var _axios = require("axios");

var _data = require("../utils/data");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Load content for specific vehicle from CD API
 *
 * @param {String} brand of the vehicle
 * @param {String} year of the vehicle
 * @param {String} model of the vehicle
 * @param {String} locale
 * @param {String} searchText
 * @param {String} [productType]
 * @param {String} [productSubtype]
 * @returns {Promise} on API initiated
 * @deprecated
 */
function getContents(brand, year, model, locale) {
  var searchText = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var productType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  var productSubtype = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
  return function (dispatch) {
    dispatch({
      type: searchText ? _.SEARCH_CONTENTS_REQUEST : _.GET_CONTENTS_REQUEST
    });
    return _ContentDelivery["default"].getContents(brand, year, model, locale, searchText).then(function (data) {
      // handle type/subtype vehicle filtering
      // TODO: move this type of filtering to either CD or ForestRiver app
      // in case of search don't filter data as at this moment we can't recognize if topic belongs to a vehicle
      // search filtering is handled on client side
      if ((productType || productSubtype) && !searchText) {
        (0, _data.filterByTypeSubType)(data, productType, productSubtype);
      }

      dispatch({
        type: searchText ? _.SEARCH_CONTENTS_SUCCESS : _.GET_CONTENTS_SUCCESS,
        payload: data
      });
    })["catch"](function (error) {
      if ((0, _axios.isCancel)(error)) {
        dispatch({
          type: searchText ? _.SEARCH_CONTENTS_CANCEL : _.GET_CONTENTS_CANCEL
        });
      } else {
        dispatch({
          type: searchText ? _.SEARCH_CONTENTS_ERROR : _.GET_CONTENTS_ERROR,
          payload: error
        });
      }
    });
  };
}
/**
 * Load content from CD API for specific vehicle by it's ID
 *
 * @param {String} vehicleId ID of the vehicle
 * @param {String} locale
 * @param {String} searchText
 * @returns {Promise} on API initiated
 */


function getContentsByVehicleId(vehicleId, locale) {
  var searchText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return function (dispatch) {
    dispatch({
      type: searchText ? _.SEARCH_CONTENTS_REQUEST : _.GET_CONTENTS_REQUEST
    });
    return _ContentDelivery["default"].getContentsByVehicleId(vehicleId, locale, searchText).then(function (data) {
      dispatch({
        type: searchText ? _.SEARCH_CONTENTS_SUCCESS : _.GET_CONTENTS_SUCCESS,
        payload: data
      });
      return data;
    })["catch"](function (error) {
      if ((0, _axios.isCancel)(error)) {
        dispatch({
          type: searchText ? _.SEARCH_CONTENTS_CANCEL : _.GET_CONTENTS_CANCEL
        });
      } else {
        dispatch({
          type: searchText ? _.SEARCH_CONTENTS_ERROR : _.GET_CONTENTS_ERROR,
          payload: error
        });
      }

      return null;
    });
  };
}
/**
 * Search content for a specific vehicle by it's ID and get results ordered by relevance
 *
 * @param {String} vehicleId ID of the vehicle
 * @param {String} locale
 * @param {String} searchText
 * @returns {Promise} on API initiated
 */


function searchContentsByVehicleId(vehicleId, locale) {
  var searchText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return function (dispatch) {
    dispatch({
      type: _.SEARCH_CONTENTS_REQUEST
    });
    return _ContentDelivery["default"].searchContentsByVehicleId(vehicleId, locale, searchText).then(function (data) {
      dispatch({
        type: _.SEARCH_RANKING_CONTENTS_SUCCESS,
        payload: data
      });
      return data;
    })["catch"](function (error) {
      if ((0, _axios.isCancel)(error)) {
        dispatch({
          type: _.SEARCH_CONTENTS_CANCEL
        });
      } else {
        dispatch({
          type: _.SEARCH_CONTENTS_ERROR,
          payload: error
        });
      }

      return null;
    });
  };
}
/**
 * Load images as blobs
 *
 * @param {Array} imageMaps
 * @returns {function(*=): Promise}
 */


function getImageMaps(imageMaps) {
  return function (dispatch) {
    dispatch({
      type: _.GET_IMAGE_MAPS_REQUEST
    });
    return _ContentDelivery["default"].getImageMaps(imageMaps).then(function (urls) {
      dispatch({
        type: _.GET_IMAGE_MAPS_SUCCESS,
        payload: urls
      });
    })["catch"](function (error) {
      if ((0, _axios.isCancel)(error)) {
        dispatch({
          type: _.GET_IMAGE_MAPS_CANCEL
        });
      } else {
        dispatch({
          type: _.GET_IMAGE_MAPS_ERROR,
          payload: error
        });
      }
    });
  };
}
/**
 * Loads assets by its object key
 *
 * @param {string} objectKey
 * @returns {function(*=): Promise}
 */


function getAsset(objectKey) {
  return function (dispatch) {
    dispatch({
      type: _.GET_ASSET_REQUEST
    });
    return _ContentDelivery["default"].getHtmlAsset(objectKey).then(function (res) {
      return _ContentDelivery["default"].processContent(res.data);
    }).then(function (html) {
      dispatch({
        type: _.GET_ASSET_SUCCESS,
        payload: {
          objectKey: objectKey,
          content: html
        }
      });
    })["catch"](function (error) {
      dispatch({
        type: _.GET_ASSET_ERROR,
        payload: error
      });
    });
  };
}
/**
 * Downloads a resource to the local file system
 * @param {String} objectKey
 * @returns {{type, payload: *}}
 */


function getFile(objectKey) {
  return function (dispatch) {
    dispatch({
      type: _.GET_FILE_REQUEST
    });
    return _ContentDelivery["default"].getFileAsset(objectKey).then(function (url) {
      dispatch({
        type: _.GET_FILE_SUCCESS,
        payload: {
          objectKey: objectKey,
          localFileUrl: url
        }
      });
    })["catch"](function (error) {
      dispatch({
        type: _.GET_FILE_ERROR,
        payload: error
      });
    });
  };
}
/**
 * Downloads a heroshot for a vehicle to the local file system
 * @param {String} brand
 * @param {String} year
 * @param {String} model
 * @param {String} locale
 * @param {String} [imageSize] image size, supported value: 'small'
 * @param {String} [productType]
 * @param {String} [productSubtype]
 * @returns {{type, payload: *}}
 */


function getHeroShot(brand, year, model, locale, imageSize, productType, productSubtype) {
  return function (dispatch) {
    dispatch({
      type: _.GET_HEROSHOT_REQUEST
    });
    return _ContentDelivery["default"].getHeroShots(brand, year, model, locale).then(function (res) {
      var filteredHeroShots = res.data.filter(function (heroshot) {
        return heroshot.vehicles.filter(function (vehicle) {
          return (productType ? vehicle.FOREST_RIVER_PRODUCT_TYPE === productType : true) && (productSubtype ? vehicle.FOREST_RIVER_PRODUCT_SUB_TYPE === productSubtype : true);
        }).length;
      });

      if (!filteredHeroShots.length) {
        return '';
      }

      return _ContentDelivery["default"].processHeroShots(filteredHeroShots, imageSize);
    }).then(function (url) {
      var key = (0, _data.getBrandYearModelTypeSubtypeKey)(brand, year, model, productType, productSubtype);
      dispatch({
        type: _.GET_HEROSHOT_SUCCESS,
        payload: {
          key: key,
          url: url
        }
      });
    })["catch"](function (error) {
      dispatch({
        type: _.GET_HEROSHOT_ERROR,
        payload: error
      });
    });
  };
}
/**
 * Downloads a heroshot file to the local file system with already loaded heroshot data
 * @param {object} heroShots heroshot data as part of contents response
 * @param {String} [imageSize] image size, supported value: 'small', 'medium'
 * @param {String} [productType]
 * @param {String} [productSubtype]
 * @returns {{type, payload: *}}
 */


function preloadHeroShot(heroShots, imageSize, productType, productSubtype) {
  return function (dispatch) {
    dispatch({
      type: _.GET_HEROSHOT_REQUEST
    });
    return _ContentDelivery["default"].processHeroShots(heroShots, imageSize).then(function (url) {
      var _heroShots$0$vehicles = heroShots[0].vehicles[0],
          make = _heroShots$0$vehicles.make,
          year = _heroShots$0$vehicles.year,
          model = _heroShots$0$vehicles.model;
      var key = (0, _data.getBrandYearModelTypeSubtypeKey)(make, year, model, productType, productSubtype);
      dispatch({
        type: _.GET_HEROSHOT_SUCCESS,
        payload: {
          key: key,
          url: url
        }
      });
    })["catch"](function (error) {
      dispatch({
        type: _.GET_HEROSHOT_ERROR,
        payload: error
      });
    });
  };
}
/**
 * Updates search query
 *
 * @param {string} query
 * @returns {{type, payload: *}}
 */


function setSearchQuery(query) {
  return {
    type: _.SET_SEARCH_QUERY,
    payload: query
  };
}